/* ======================================================================== */
/* 7. figureFeature */
/* ======================================================================== */
var FigureFeature = function ($scope) {

	var
		$link = $scope.find('a.figure-feature'),
		$target = $scope.find('.figure-feature[data-os-animation]'),
		tl = new TimelineMax(),
		$heading = $target.find('.figure-feature__header h3'),
		$descr = $target.find('.figure-feature__header p'),
		splitHeading = splitLines($heading),
		splitDescr = splitLines($descr),
		circle = new Circle();

	prepare();
	animate();

	function prepare() {

		if (!$target.length) {
			return;
		}

		setLines(splitHeading.words);
		setLines(splitDescr.words);

	}

	function animate() {

		if (!$target.length) {
			return;
		}

		tl
			.add(animateLines(splitHeading.words))
			.add(animateLines(splitDescr.words), '-=0.6')

		createOSScene($target, tl);

	}

	$link.each(function () {
		var $el = $(this);
		circle.animate($el);
	});

}
